;



// Custom Functions
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

window.studiesPlayer = {
    current_id: 0,
    seek_time: 10,
    playerInstance: null,
    track: null,
    ud_time: 5000,
    userdataTimer: null,
    seekinterval: null,
    fullscreenStatus: false,
    playbackRates: [1,1.1,1.2,1.3,1.5,1.75,2, 2.5],

    init: function () {
        studiesPlayer.userSettings.load();
    },

    player: function(player) {
        if (player) { studiesPlayer.playerInstance = player; }
        return studiesPlayer.playerInstance;
    },

    loadSettings: function () {
        if (this.userSettings.get('volume')) { studiesPlayer.player().setVolume(studiesPlayer.userSettings.get('volume')); }
        if (this.userSettings.get('playbackRate')) { studiesPlayer.player().setPlaybackRate(studiesPlayer.userSettings.get('playbackRate')); }
        setTimeout(function() {
            // Default workaround
            if (!studiesPlayer.userSettings.isset('captionsEnabled')) {
                studiesPlayer.player().setCaptionsEnabled(true);
                studiesPlayer.userSettings.set('captionsEnabled', true);
            } else {
                if (studiesPlayer.userSettings.get('captionsEnabled')) { studiesPlayer.player().setCaptionsEnabled(studiesPlayer.userSettings.get('captionsEnabled')); }
            }
        }, 1000);
    },


    // Setup the player
    setup: function() {
        this.player(window.video);
        this.player().availablePlaybackRates = this.playbackRates;
        this.loadSettings();
    },

    roundDecimal: function(num) {
        return Math.round(num * 10) / 10;
    },

    captions: function() {
        this.userSettings.set('captionsEnabled', this.player().captionEnabled);
    },

    // +1 or -1
    playbackrate(dir) {
        var currentRate = this.player().playbackRate;
        if (dir) {
            var index = this.playbackRates.indexOf(currentRate);
            var newRate = this.playbackRates[index+dir];
            if (newRate) {
                this.player().setPlaybackRate(newRate);
                this.userSettings.set('playbackRate', newRate);
            }
        } else {
            this.userSettings.set('playbackRate', currentRate);
        }
    },

    volume: function (direction) {
        var volume = this.player().volume;
        if (!direction) { return volume; }
        if (volume === "+" || volume === "-") {
            volume = (direction === "+") ? volume += 0.1 : volume -= 0.1;
            this.player().setVolume(this.roundDecimal(volume));
        }
        console.log('setting vol to: ' + this.roundDecimal(volume));
        this.userSettings.set('volume', this.roundDecimal(volume.toString()));
    },

    reset: function() {
        setTimeout(function() {

            // Load settings
            if (studiesPlayer.userSettings.get('volume')) { studiesPlayer.player().volume(studiesPlayer.userSettings.get('volume')); }
            if (studiesPlayer.userSettings.get('playbackRate')) { studiesPlayer.player().playbackRate(studiesPlayer.userSettings.get('playbackRate')); }

            studiesPlayer.player().play();

            // Mouse actions
            studiesPlayer.player().on('mouseout', function () { studiesPlayer.player().controlBar.addClass('vjs-fade-out'); });
            studiesPlayer.player().on('mouseover', function () { studiesPlayer.player().controlBar.removeClass('vjs-fade-out'); });

            // Load next on ended
            studiesPlayer.player().on('ended', function () { studiesPlayer.getNextVideo(); });

            // not sure.
            studiesPlayer.player().error();

            studiesPlayer.player().on('fullscreenchange', function (fs, x, y) {
                studiesPlayer.fullscreenStatus = !studiesPlayer.fullscreenStatus;
                studiesPlayer.positionUserData();
            });

            studiesPlayer.player().on('volumechange', (fs) => { studiesPlayer.userSettings.copyVolume(); });

            clearTimeout(studiesPlayer.userdataTimer);

            studiesPlayer.showuserdata();
            var captionOptions = document.createElement('li');
            captionOptions.className = "caption-options";
            captionOptions.innerHTML = "הגדרות";
            $(".vjs-captions-button ul").append(captionOptions);
            $(".caption-options").click(function () {
                // showcaptionsmenu();
            });
        }, 1500);
    },

    changeRate: function(rate) {
        var currentRate = studiesPlayer.player().playbackRate;
        var index = playbackRates.indexOf(currentRate);
        var newindex = index + rate;
        var newrate = playbackRates[newindex];
        if (index !== false) {
            if (newrate) {
                player.playbackRate(newrate);
                userSettings.set('playbackRate', newrate);
            }
        } else {
            // fallback
            userSettings.set(playbackRate, 1);
            player.playbackRate(1);
        }
    },
    userSettings: {
        load: function () {
            studiesPlayer.userSettings.config = JSON.parse(getCookie('studiesPlayerConfig')) || {};
        },

        config: {},
        set: function (type, value) {
            studiesPlayer.userSettings.config[type] = value;
            setCookie('studiesPlayerConfig', JSON.stringify(studiesPlayer.userSettings.config));
        },
        isset: function (type) {
            return typeof studiesPlayer.userSettings.config[type] !== 'undefined';
        },
        get: function (type) {
            return studiesPlayer.userSettings.config[type] || null;
        },
        copyVolume: function () {
            studiesPlayer.userSettings.set('volume', studiesPlayer.player().volume());
        }
    },

};

studiesPlayer.init();

// No event, so we add this here.
jQuery(document).on("click", "button.ytp-subtitles-button", function(e) {
    console.log(e);
    studiesPlayer.captions();
});


jQuery(document).ready(function($) {

    $("#close").click(function() {
        $(".green-form").hide()
        $("#open").show()
    });

    $("#open").click(function() {
        $(".green-form").show()
        $("#open").hide()
    });

    // Player
    window.scrollUpHover = false;
    window.scrollClicked = false;
    window.scrollUp = function(distance) { // 100
        $('.p-selector-clips').animate({
            scrollTop: $('.p-selector-clips').scrollTop() - distance
        }, 300);
    }

    window.scrollDownHover = false;
    window.scrollDown = function (distance) { // 100
        $('.p-selector-clips').animate({
            scrollTop: $('.p-selector-clips').scrollTop() + distance
        }, 300);
    }

    window.varScrollUpFunction = _.debounce(function() { window.scrollUp(50) }, 1000, true);
    setInterval(function() {
        if (window.scrollClicked) { window.scrollClicked = false; return; }
        if (window.scrollUpHover) { window.varScrollUpFunction() }
    }, 750)

    window.varScrollDownFunction = _.debounce(function() { window.scrollDown(50) }, 1000, true);

    setInterval(function() {
        if (window.scrollClicked) { window.scrollClicked = false; return; }
        if (window.scrollDownHover) { window.varScrollDownFunction() }
    }, 750)


    $(".player-up").click(function() {
        window.scrollClicked = true;
        window.scrollUp(100);
    });

    $(".player-down").click(function() { window.scrollDown(100); });

    $(".player-up").hover(
        function () { window.scrollUpHover = true; },
        function () { window.scrollUpHover = false; }
    );

    $(".player-down").hover(
        function () { window.scrollDownHover = true; },
        function () { window.scrollDownHover = false; }
    );

    // scrollUp(50);

    $(".p-selector li").click(function(e) {
        const video = $(e.target);
        loadVideo(video.data('clip'));
    })
});

